module.exports = __webpack_public_path__ + "4da6d2be771752a68d4f0f0911a26f62.pdf";